import React from 'react';
import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';

interface MonthYearPickerProps {
  value: string | null;
  onChange: (value: string | null) => void;
  label?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

const MonthYearPicker: React.FC<MonthYearPickerProps> = ({
  value,
  onChange,
  label = 'Cohort Start Month',
  disabled = false,
  error = false,
  helperText,
}) => {
  // Calculate date restrictions - past 36 months from current date
  const currentDate = dayjs();
  const minDate = currentDate.subtract(36, 'month').startOf('month');
  const maxDate = currentDate.subtract(1, 'month').endOf('month');

  // Convert string value to dayjs object
  const selectedDate = value ? dayjs(value + '-01') : null;

  const handleDateChange = (newValue: Dayjs | null) => {
    if (newValue && newValue.isValid()) {
      // Format as YYYY-MM to match the existing interface
      const formattedValue = newValue.format('YYYY-MM');
      onChange(formattedValue);
    } else {
      onChange(null);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          value={selectedDate}
          onChange={handleDateChange}
          views={['year', 'month']}
          format="YYYY-MM"
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          slotProps={{
            textField: {
              error: error,
              helperText: helperText,
              sx: {
                minWidth: 200,
                fontSize: '16px',
                fontWeight: 500,
                lineHeight: '22px',
                fontFamily: 'Manrope',
                color: '#162936',
              },
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default MonthYearPicker;
